import { FormErrorJSON } from 'src/app/shared/models/form-errors';
import { BDPSearchFormKeysType } from '../../../models/search-form';

export const formSearchAWBErrors: FormErrorJSON<BDPSearchFormKeysType> = {
    awb: [
        {
            code: 'required',
            message: 'Required field',
        },
        {
            code: 'invalid',
            message: 'The AWB is invalid, please review the format',
        },
        {
            code: 'maxlength',
            message: `Maximum of 250 characters`,
        },
    ],
    hawbId: [
        {
            code: 'required',
            message: 'Required field',
        },
        {
            code: 'invalid',
            message: 'The BDP reference number is invalid, please review the format',
        },
        {
            code: 'maxlength',
            message: `Maximum of 250 characters`,
        },
    ],
    amount: [
        {
            code: 'required',
            message: 'Required field',
        },
        {
            code: 'invalid',
            message: 'The amount is invalid',
        },
    ],
};
